<template>
  <div class="page">
    <problem-list ref="problem-List" :taskList="taskList" />
  </div>
</template>

<script>
import ProblemList from "./components/problemList.vue";
export default {
  components: { ProblemList },
  data() {
    return {
      taskList: [
        { taskId: "Activity_1ljcp7e", taskName: "措施审批-类型二" },
        { taskId: "Activity_16j4rta", taskName: "措施审批" },
        { taskId: "Activity_193ui3v", taskName: "根因分析-审批" },
        { taskId: "Activity_0x5zyud", taskName: "永久方案-审批" }
      ]
    };
  },
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped></style>
